










































import { Component, Prop, Mixins } from 'vue-property-decorator'
import BaseVue from '@/mixins/BaseVue'
import serviceModule from '@/store/modules/ServiceModule'

@Component({
  components: {}
})
export default class ImportPromotionDialog extends Mixins(BaseVue) {
  @Prop({ default: false })
  public value!: boolean

  public file?: File = {} as File
  public errors: string[] = []
  public loading = false

  public mounted () {
    this.file = undefined
  }

  public closeDialog () {
    this.file = undefined
    this.errors = []
    this.loading = false
    this.$emit('close', false)
  }

  public async upload () {
    try {
      this.loading = true
      if (this.file) {
        const result = await serviceModule.promotionApi.importExcelPromotions({
          data: this.file,
          fileName: this.file.name
        })

        if (result === null) {
          this.displayMessage(this.$t('promotion.uploadSuccess'))
          this.closeDialog()
        } else {
          this.errors = result
          this.displayError(this.$t('promotion.uploadErrors'))
        }
      }
    } catch (error) {
      this.displayError(error)
    }

    this.loading = false
  }
}
